import React from "react";
import styled from "styled-components";

import System from "src/types/System";
import { formatDate } from "src/utils/format";
import { PwsSubmissionPeriod } from "src/services";

interface Props {
  system: System;
}

const SubmissionPeriodCell: React.FC<Props> = ({ system }: Props) => {
  const { pwsSubmissionPeriods } = system;
  const activePWSSubmissionPeriods: PwsSubmissionPeriod[] = pwsSubmissionPeriods.filter(psp => psp.active);

  return (
    <Container>
      {activePWSSubmissionPeriods.map((sp) => (
        <div key={`sp_${system.id}_${sp.submissionPeriod.id}`}>
          <p>{sp.submissionPeriod.name || "--"}</p>
          <p>{`Due Date: ${formatDate(sp.submissionPeriod.dueDate)}`}</p>
        </div>
      ))}
    </Container>
  );
};

const Container = styled.div`
  font-size: 14px;
  line-height: 1.5;

  p {
    margin: 0px 0px;
  }
`;

export default SubmissionPeriodCell;
